<template>
  <div class="profile__container">
    <div class="profile__header">
      <div class="profile__headerLeft">
        <img src="/img/logo_mark.png" alt="" />
      </div>
      <div class="profile__headerRight" @click="moveDownload()" href="">
        {{ $t('openApp') }}
      </div>
    </div>

    <div v-show="shouldShowProfile()" class="profile__userContainer">
      <img v-bind:src="iconUrl" class="profile__thumbnail" />

      <div class="profile__nicknameAndFollowContainer">
        <h1 class="profile__nickname">{{ nickname }}</h1>
        <div class="profile__followBtn" @click="moveDownload()" href="">
          ＋ {{ $t('followAction') }}
        </div>
      </div>

      <div class="profile__followListContainer">
        <div class="profile__followlist">
          <span class="profile__followlist--Number">{{ followCount }}</span>
          {{ $t('profileFollow') }}
        </div>
        <div class="profile__followlist">
          <span class="profile__followlist--Number">{{ followerCount }}</span>
          {{ $t('profileFollower') }}
        </div>
        <div v-if="twitterUrl" class="profile__snsLink">
          <a v-bind:href="twitterUrl">
            <img
              src="../../../public/img/x_icon_black_circle.png"
              height="32"
            />
          </a>
        </div>
      </div>
      <div>
        <span>
          {{ description }}
        </span>
      </div>
    </div>

    <loading
      v-show="shouldShowLoading()"
      class="profile__userLoading"
    ></loading>

    <not-found v-show="shouldShow404()" class="profile__notfound"></not-found>
  </div>
</template>

<script>
import APIRequest from '@/utils/APIRequest'
import Loading from '@/components/Loading.vue'
import NotFound from '@/components/Error/NotFound.vue'
import { redirectToTrackerURLIfNeeded } from '@/utils/adjust_redirector'

export default {
  name: 'user',
  components: {
    Loading,
    NotFound,
  },
  data: function () {
    return {
      profileId: '',
      iconUrl: '',
      nickname: '',
      followCount: -1,
      followerCount: -1,
      description: '',
      twitterUrl: '',
      loading: true,
      setting: false,
    }
  },
  created() {
    redirectToTrackerURLIfNeeded()
  },
  async mounted() {
    this.profileId = location.pathname.replace('/profile/', '')

    const response = await this.fetchProfile()
    if (response.streamer) {
      this.iconUrl = response.streamer.iconUrl
      this.nickname = response.streamer.nickname
      this.followCount = response.streamer.followCount
      this.followerCount = response.streamer.followerCount
      this.description = response.streamer.description
      this.twitterUrl = response.streamer.snsProps.sns_twitter_url
      this.setting = this.iconUrl != '' && this.nickname != ''
    }
    this.loading = false
  },
  methods: {
    fetchProfile: async function () {
      const response = await this.$loader.post(
        new APIRequest(
          this.$config.appGatewayServerUrl,
          '/streamer/get_from_profile_id',
          {
            profileId: this.profileId,
          }
        )
      )
      return response
    },
    shouldShowLoading() {
      return this.loading
    },
    shouldShowProfile() {
      return !this.loading && this.setting
    },
    shouldShow404() {
      return !this.loading && !this.setting
    },
    moveDownload() {
      location.href = '/download'
    },
  },
}
</script>

<style>
.profile__container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}

.profile__userContainer {
  max-width: 768px;
  width: 100%;
  height: 93%;
  margin: 0 auto;
  padding: 20px 16px;
  font-size: 14px;
}

.profile__thumbnail {
  width: 100px;
  margin-bottom: 10px;
  border-radius: 50px;
}

.profile__nicknameAndFollowContainer {
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
}

.profile__nickname {
  width: 70%;
  margin-right: 16px;
  font-size: 20px;
  line-height: 26px;
  font-weight: bold;
}

.profile__followBtn {
  width: 104px;
  min-width: 104px;
  height: 26px;
  border-radius: 13px;
  background-color: #f2f2f2;
  color: #0f0f0f;
  border: none;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  line-height: 23px;
  cursor: hand;
  cursor: pointer;
}

.profile__followBtn:hover {
  opacity: 0.6;
}

.profile__followListContainer {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 7px;
}

.profile__followlist {
  margin-right: 16px;
  color: #808080;
  line-height: 32px;
}

.profile__followlist--Number {
  color: #262626;
  font-weight: bold;
}

.profile__snsLink {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: hand;
  cursor: pointer;
}

.profile__snsLink:hover {
  opacity: 0.6;
}

.profile__userLoading {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
}

.profile__notfound {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
}

.profile__header {
  width: 100%;
  min-height: 50px;
  padding: 8px 16px;
  top: 0px;
  flex: 0 0 auto;
  box-shadow: 0 -8px 34px 0 rgba(0, 0, 0, 0.1);
  background-color: white;
  display: flex;
  justify-content: space-between;
}

.profile__headerLeft {
  display: flex;
  flex-direction: column;
  margin-top: 8px;
}

.profile__headerLeft img {
  width: 112px;
}

.profile__headerRight {
  flex-direction: column;
  background-color: #188dff;
  height: 34px;
  width: 117px;
  border-radius: 17px;

  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 14px;
}
</style>
